
<script>

  export default {
    Brick: function (size) {
      return {
        rows: new Array(),
        bingoRows: new Array(),
        bingoCols: new Array(),
        size: size
      }
    },
    BrickRow: function () {
      return {
        items: new Array()
      }
    },
    BrickItem: function (item,checked,id) {
      return {
        item: item,
        checked: checked,
        bingo: false,
        id: id
      }
    },
  }

</script>



// WEBPACK FOOTER //
// src/Factory.vue